<template>
    <div>
        <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div class="e-mtavr-15">დაუმუშავებელი მოთხოვნები </div>
      <!-- <button class="btn btn-primary" @click="refreshToken">a</button> -->
    </h4>

     <div class="row">
      <div class="col-md-12 col-lg-12 col-sm-12 col-xl-12">
      <add-new-request @RequestAdded="refreshRequests()"></add-new-request>
         <vue-good-table
            ref="requestsTable"
            :columns="RR_Table_Columns"
            :rows="RR_Table_Rows"
            class="vgt-table bordered condensed e-table-1 e-dynamic-filter e-ts-12"
            :search-options="{enabled: true, placeholder: 'ძებნის პარამეტრი'}"
            :sort-options="{enabled: true, initialSortBy: {field: 'id', type: 'desc'}}"
            :row-style-class="rowStyleClassFn"
            @on-row-click="RR_Table_RowClick"
            :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 25,
                                    position: 'top',
                                    perPageDropdown: [50, 75, 100],
                                    dropdownAllowAll: false,
                                    setCurrentPage: 1,
                                    nextLabel: 'შემდეგი',
                                    prevLabel: 'წინა',
                                    rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
                                    ofLabel: '-ჩანაწერი სულ',
                                    pageLabel: 'გვერდი', // for 'pages' mode
                                    allLabel: 'ყველა',
                                  }"
          >
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'ScrStatus'">
                <div
                  v-if="props.row.matchCount > 0"
                  class="badge badge-danger e-nusx-8"
                >საყურადღებო</div>
                <div v-else class="badge badge-success e-nusx-8">არცერთი დამთხვევა</div>
              </div>
              <!-- <div v-else-if="props.column.field == 'functions'" class="e-whitespace-nowrap">
                <button
                  class="btn btn-info icon-btn btn-sm"
                  title="სკანირების რეზულტატების ნახვა"
                  v-if="props.row.matchCount > 0"
                >
                  <span class="lnr lnr-magnifier"></span>
                </button>
              </div> -->
            </template>
         </vue-good-table>
         </div>
         </div>
    </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import addNewRequest from '../components/addNewRequest'
import moment from 'moment'
import XLSX from 'xlsx'
export default {
  name: 'NotProcessedRequests',
  components: {
    addNewRequest
  },
  metaInfo: {
    title: ' - დაუმუშავებელი მოთხოვნები'
  },
  data () {
    return {
      RR_Table_Columns: [
        {
          label: '#',
          type: 'number',
          thClass: 'e-ts-12',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'სქრინინგ სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'ScrStatus'
        },
        {
          label: 'მოთხოვნის სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'statusText'
        },
        {
          label: 'სასურველი დამთხვევის %',
          field: 'matchPercent',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-08rem',
          tdClass: 'text-center',
          type: 'number'
        },
        {
          label: 'საძიებო ტექსტი',
          html: true,
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'SearchedCriteria'
        },
        {
          label: 'მისამართი',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          html: true,
          field: 'FullAddress'
        },
        {
          label: 'იდენტიფიკატორი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'personalN'
        },
        {
          label: 'მოთხოვნის დრო',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'recDate'
        },
        {
          label: 'ტრანზაქციის ID',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'transactionN'
        },
        // {
        //   label: 'ქვეყანა',
        //   type: 'text',
        //   thClass: 'e-mtavr-17 e-ts-12',
        //   tdClass: 'e-ts-12'
        // },
        {
          label: 'ბოლო კომენტარი',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          html: true,
          field: 'LastCommentItem'
        }, {
          label: 'მომხმარებელი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'LastActionUser'
        }
        // {
        //   label: 'ფუნქციები',
        //   field: 'functions',
        //   thClass: 'e-mtavr-17 e-ts-12',
        //   tdClass: 'e-ts-12'
        // }
      ],
      RR_Table_Rows: []
    }
  },
  beforeCreate () {
    const grsdata = {
      headers: {
        accept: 'text/plain',
        Authorization: ''
      }
    }
    grsdata.headers.Authorization = 'Bearer ' + this.$store.getters.getAccessToken
    // console.log(grsdata.sessionId);
    BaseService.GetRequests(grsdata)
      .then(response => {
        // console.log(response.data.result)

        if (response.data.success) {
          response.data.result = response.data.result.filter(item => {
            return item.status === 1
          })
          for (var i = 0, len = response.data.result.length; i < len; i++) {
            if (response.data.result[i].brthDate === null) {
              response.data.result[i].brthDate = 'თარიღი ცარიელია'
            } else {
              response.data.result[i].brthDate = moment(response.data.result[i].brthDate).format('DD.MM.YYYY')
            }
            if (response.data.result[i].recDate === null) {
              response.data.result[i].recDate = 'თარიღი ცარიელია'
            } else {
              response.data.result[i].recDate = moment(response.data.result[i].recDate).format('DD.MM.YYYY HH:mm:SS')
            }
            response.data.result[i].SearchedCriteria = 'სახელი და გვარი / დასახელება: <strong>' + response.data.result[i].firstName + ' ' + response.data.result[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + response.data.result[i].brthDate + '</strong>'
            response.data.result[i].FullAddress = 'ქვეყანა: <strong>' + response.data.result[i].country + '</strong></br> მისამართი: <strong>' + response.data.result[i].address + '</strong>'
            response.data.result[i].LastCommentItem = 'კომენტარი: <strong>' + response.data.result[i].commentText + '</strong></br> ავტორი: <strong>' + (response.data.result[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : response.data.result[i].commentUserName) + '</strong>'
            response.data.result[i].LastActionUser = response.data.result[i].userFirstName + ' ' + response.data.result[i].userLastName
          }
          this.RR_Table_Rows = response.data.result
        } else {
          return null
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    exportToExcel () {
      const sheetData = []
      var data = this.$refs.requestsTable.filteredRows[0].children
      data.map(res => {
        sheetData.push({
          'სქრინინგ სტატუსი': res.matchCount > 0 ? 'საყურადღებო' : 'არცერთი დამთხვევა',
          'მოთხოვნის სტატუსი': res.statusText,
          'სასურველი დამთხვევის %': res.matchPercent,
          'სახელი / დასახელება': res.firstName,
          გვარი: res.lastName,
          ქვეყანა: res.country,
          მისამართი: res.address,
          იდენტიფიკატორი: res.personalN,
          'მოთხოვნის დრო': res.recDate,
          'ტრანზაქციის ID': res.transactionN,
          'ბოლო კომენტარი': res.commentText,
          მომხმარებელი: res.userFirstName + ' ' + res.userLastName
        })
      })
      var newWB = XLSX.utils.book_new()
      var newWS = XLSX.utils.json_to_sheet(sheetData)
      XLSX.utils.book_append_sheet(newWB, newWS, 'Data')
      XLSX.writeFile(newWB, 'RequestsExport-' + moment(Date.now()).format('DD.MM.YYYY') + '.xlsx')
    },
    refreshRequests () {
      const grsdata = {
        headers: {
          accept: 'text/plain',
          Authorization: ''
        }
      }
      grsdata.headers.Authorization = 'Bearer ' + this.$store.getters.getAccessToken
      // console.log(grsdata.sessionId);
      BaseService.GetRequests(grsdata)
        .then(response => {
          if (response.data.success) {
            response.data.result = response.data.result.filter(item => {
              return item.status === 4
            })
            for (var i = 0, len = response.data.result.length; i < len; i++) {
              if (response.data.result[i].brthDate === null) {
                response.data.result[i].brthDate = 'თარიღი ცარიელია'
              } else {
                response.data.result[i].brthDate = moment(response.data.result[i].brthDate).format('DD.MM.YYYY')
              }
              if (response.data.result[i].recDate === null) {
                response.data.result[i].recDate = 'თარიღი ცარიელია'
              } else {
                response.data.result[i].recDate = moment(response.data.result[i].recDate).format('DD.MM.YYYY HH:mm:SS')
              }
              response.data.result[i].SearchedCriteria = 'სახელი და გვარი / დასახელება: <strong>' + response.data.result[i].firstName + ' ' + response.data.result[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + response.data.result[i].brthDate + '</strong>'
              response.data.result[i].FullAddress = 'ქვეყანა: <strong>' + response.data.result[i].country + '</strong></br> მისამართი: <strong>' + response.data.result[i].address + '</strong>'
              response.data.result[i].LastCommentItem = 'კომენტარი: <strong>' + response.data.result[i].commentText + '</strong></br> ავტორი: <strong>' + (response.data.result[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : response.data.result[i].commentUserName) + '</strong>'
              response.data.result[i].LastActionUser = response.data.result[i].userFirstName + ' ' + response.data.result[i].userLastName
            }
            this.RR_Table_Rows = response.data.result
          } else {
            return null
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    rowStyleClassFn (row) {
      if (row.statusText === 'მუშავდება') {
        return 'e-bg-investigating'
      }
      // if (row.statusText === 'დაუმუშავებელი') {
      //   return 'bg-secondary'
      // }
      if (row.statusText === 'დადასტურებული') {
        return 'e-bg-approved'
      }
      if (row.statusText === 'დაბლოკილი') {
        return 'e-bg-declined'
      }
      if (row.statusText === 'მეორე დონის ავტორიზაციის მოლოდინში') {
        return 'e-bg-secondaryApproval'
      }
      // if (row.matchCount === 0) {
      //   return 'border-success bg-transparent'
      // }
    },
    RR_Table_RowClick (params) {
      if (params.row.matchCount > 0) {
        const data = params.row
        this.$router.push({
          path: '/Aml/Requests/InvestigatingRequest',
          query: { data }
        })
      } else {

      }
      // const data = {
      //   status: true,
      //   rowData: {}
      // }
      // data.rowData = params.row
      // this.$store.commit('setInvestigationStatus', data)
      // this.$emit('ChangeStatus')
      // // console.log(params)
    }
  }
}
</script>
